import './SignupOnboardingPage.pcss';
import React, { ReactNode } from 'react';
import { Logo } from '../../../../../layout/BotBuilderSidebar/Logo/Logo';

type Props = {
  className?: string;
  children: ReactNode | Element[];
};

const SignupOnboardingPage = (props: Props) => {
  const { children, className } = props;

  return (
    <div className="signup-onboarding-page">
      <div className="signup-onboarding-page__body-wrapper">
        <div className="signup-onboarding-page-left">
          <Logo className="signup-onboarding-page-logo" />
        </div>

        <div className="signup-onboarding-page__route-wrapper">
          <div className={className}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default SignupOnboardingPage;
